import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { useParams } from "react-router-dom";

import { getOrgById } from "../models/OrgFunctions.js";
import { transformArticlesToTable } from "../models/ArticleFunctions.js";
import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space";
import SecondaryButton from "../buttons/SecondaryButton";

import PrimaryButton from "../buttons/PrimaryButton";
import ClientsAM from "../actionmenus/ClientsAM.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  last_of_list,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import NotesClient from "../notes/NotesClient.js";
import { useSnackbar } from "notistack";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";

import Modal1 from "../modals/Modal1.js";
import TextField2 from "../textfields/TextField2";
import SmallSpinner from "../loading/SmallSpinner.js";
import MembresClient from "../members/MemberClient";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";

import MemberModal from "../modals/MemberModal.js";
import CustomAccordion from "../layout/CustomAccordion.js";

import { EasySwitch, ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import { Spin } from "antd";
import { InfoCell } from "./carnets/CarnetPage";
import { Org, Workspace } from "../types/org";
import { User } from "../types/user";

interface PartnerProps {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  workspaceData: Workspace | null;
}

function Partner({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
}: PartnerProps) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [users, setUsers] = useState<User[]>([]);

  const [partnerData, setPartnerData] = useState<Org | null>(null);

  const [articles, setArticles] = useState([]);
  const [role, setRole] = useState("");

  const [workspace, setWorkspaceData] = useState<Workspace | null>(null);

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    try {
      const partner = (await getDocDataById("org", id)) as Org;
      console.log("Partner data:", partner);
      const partner_workspaces = (await getArrayDocDataByID(
        "workspace",
        partner.workspaces_id
      )) as any as Workspace[];
      console.log("Partner workspaces:", partner_workspaces);
      let workspace = partner_workspaces.find(
        (workspa) => workspa.master_id === orgData.id
      );
      if (!workspace) {
        handleClickVariant("Workspace client non trouvé", "error");
        navigateWorkspace("/partners");
        return;
      }
      setWorkspaceData(workspace);
      if (!partner) {
        handleClickVariant("Partenaire non trouvé", "error");
        navigateWorkspace("/partners");
      }

      const users = (await getArrayDocDataByID(
        "user",
        partner.users_id
      )) as User[];
      setUsers(users);

      // Transform articles into table format

      setPartnerData(partner);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  const handleSaveAdmin = async (permissions: any) => {
    if (!workspace) return;
    await updateDocDataFieldApi(
      workspace.ref,
      "permissions",
      permissions,
      prefix
    );
    handleClickVariant("Administrateur enregistré", "success");
    handleFetchData();
  };

  const handlesendInvite = async () => {
    if (!partnerData) return;
    let new_user = (await getDocDataById(
      "user",
      partnerData.users_id[0]
    )) as User;
    let org = (await getOrgById(new_user.org_id)) as Org;
    if (org.invite !== "accepted") {
      await updateDocDataFieldApi(org.ref, "invite", "sent", prefix);
    }
    // await sendInvite(
    //   new_user.id,
    //   orgData.name,
    //   new_user.email,
    //   org.id,
    //   token,
    //   prefix
    // ); // Call the sendInvite API
    handleClickVariant("Invitation envoyée avec succès", "success");
  };

  const [loadingMarque, setLoadingMarque] = useState(false);

  const [memberOpen, setMemberOpen] = useState<any>(false);

  // Handle navigation to clients page
  const gotoPartners = () => {
    navigateWorkspace("/partners");
  };

  const gomodifyClient = () => {
    navigateWorkspace("/modifypartner/" + id);
  };

  useEffect(() => {
    if (orgData && userData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [orgData, userData]); // Dependency array ensures this runs when currentUser changes
  // loading || !currentUser || !userData

  if (loading || !currentUser || !userData || !partnerData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3">
        {/* Left Column Skeleton */}
        <SmallSpinner />
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full overflow-auto gap-10 flex ">
      <Modal1 isOpen={memberOpen} onClose={() => setMemberOpen(null)}>
        <MemberModal
          onClose={() => setMemberOpen(null)}
          user_id={memberOpen}
          onUpdate={handleFetchData}
          orgData={partnerData}
        />
      </Modal1>

      {/* Left Column: Takes all available space */}
      <div className="flex flex-col h-fit flex-grow pl-4 gap-1  max-w-c1k">
        <Space y={20} />
        <div className="w-full flex flex-row ">
          <div
            className="w-fit cursor-pointer flex flex-row items-center"
            onClick={gotoPartners}
          >
            <div className="text-h2 font-semibold text-primary_l bg-transparent">
              Partenaires
            </div>
            <Icon1 icon_name="right" height="15px"></Icon1>
          </div>

          <div className="flex flex-row justify-end gap-2 w-full ">
            <SecondaryButton className="min-w-fit" onClick={handlesendInvite}>
              Envoyer invitation
            </SecondaryButton>
            <ClientsAM
              userData={userData}
              masterData={orgData}
              actionModify={gomodifyClient}
              clientData={partnerData}
              navigateWorkspace={navigateWorkspace}
            />
          </div>
        </div>
        <Space y={5} />
        <div className="text-hx font-semibold">{partnerData?.name}</div>
        <div
          className={`inline-flex w-fit items-center mt-2 rounded-full text-h3 px-2 py-0.5 flex-row ${
            partnerData.partner_type === "constructor"
              ? "text-indigo-500 bg-indigo-50"
              : "text-blue-400  bg-blue-50 "
          }  font-light `}
        >
          {getPartnerTypeName(partnerData?.partner_type)}
        </div>

        <Space y={15} />
        <CustomAccordion userData={userData} title="Membres">
          <MembresClient
            title=""
            users={users}
            orgData={partnerData}
            prefix={prefix}
            handleRefresh={handleFetchData}
            setMemberOpen={setMemberOpen}
            removable={false}
          ></MembresClient>
        </CustomAccordion>

        <CustomAccordion
          userData={userData}
          title="Configuration du partenaire"
        >
          <div className="flex flex-col gap-2 pl-2 max-w-c500 ">
            <div className="text-h2 mt-6 font-medium">
              Paramètres du partenaire
            </div>
            <div className="text-h3 font-regular text-shadow_50 ">
              Vous pouvez paramètrer le fonctionnement du débloquage des
              rapports
            </div>{" "}
            <ToggleSettingsBrick
              title="Déposer des documents"
              description={
                "Le partenaire peut déposer des documents dans les carnets"
              }
              checked={workspace?.permissions?.payment_allowed}
              disabled={true}
              onChange={(checked: any) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  payment_allowed: checked,
                });
              }}
            ></ToggleSettingsBrick>
            <ToggleSettingsBrick
              title="Ajouter des équipements"
              description={
                "Le partenaire peut ajouter des équipements dans les carnets"
              }
              checked={workspace?.permissions?.payment_allowed}
              disabled={true}
              onChange={(checked: any) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  payment_allowed: checked,
                });
              }}
            ></ToggleSettingsBrick>{" "}
            <ToggleSettingsBrick
              title="Inviter des partenaires"
              description={
                "Le partenaire peut inviter des partenaires dans les carnets"
              }
              disabled={true}
              checked={workspace?.permissions?.payment_allowed}
              onChange={(checked: any) => {
                handleSaveAdmin({
                  ...workspace?.permissions,
                  payment_allowed: checked,
                });
              }}
            ></ToggleSettingsBrick>
          </div>
        </CustomAccordion>
        <Space y={100} />
      </div>

      {/* Right Column: Fixed width */}
      <div className="flex flex-col h-full min-w-c400 pl-2">
        <div className="text-h1 font-semibold mt-6">Informations</div>
        <div className="flex flex-col gap-2 w-full pr-2 mt-6">
          <InfoCell
            title="Création"
            data={new Date(
              partnerData?.creation_date?.seconds * 1000
            ).toLocaleString()}
          />

          <InfoCell title="Entreprise" data={partnerData?.name} />
          <InfoCell title="Type" data={partnerData?.client_type} />
          <InfoCell title="Email" data={partnerData?.email} />
          <InfoCell title="Téléphone" data={partnerData?.infos?.phone} />
          <InfoCell title="Ville" data={partnerData?.infos?.ville} />
          <InfoCell title="Postal" data={partnerData?.infos?.postal} />
          <InfoCell title="Adresse" data={partnerData?.infos?.adresse} />
        </div>
        {/* Notes section */}
        <Space y={25} />
        <>
          <Space y={25} />
          <div className="text-h1 font-semibold">Notes</div>
          <Space y={5} />
          <div className="pr-3 w-full max-w-c400">
            <NotesClient
              userData={userData}
              orgData={orgData}
              onUpdate={handleFetchData}
              workspaceData={workspace}
            ></NotesClient>
          </div>
        </>{" "}
        <Space y={25} />
        <>
          <div className="text-h1 font-semibold mt-4">Espace</div>
          <Space y={5} />
          <div className="pr-3 w-full max-w-c400 gap-2 flex flex-col">
            <TextField2
              value={workspace?.id}
              label="Espace ID"
              disabled={true}
            ></TextField2>
          </div>
        </>
      </div>
    </div>
  );
}

export default Partner;

export function getPartnerTypeName(type: string) {
  switch (type) {
    case "constructor":
      return "Constructeur";
    case "mdo":
      return "Maître d'oeuvre";
    case "architect":
      return "Architecte";
    case "artisan":
      return "Artisan";
    case "drawer":
      return "Dessinateur";
    case "expert":
      return "Bureau d'étude";
    case "promotor":
      return "Promoteur";
    case "particulier":
      return "Particulier";
    case "infiltro":
      return "Infiltromètre";
    case "other":
      return "Autre";
    default:
      return "Client inconnu";
  }
}
